export const CIBLES = ["BOSS", "GROUILLEUR", "TOUS"];
export const REGLES = [
  "TAUX_COMMISSION",
  "CAGNOTTE",
  "CAUTION",
  "LIVRAISON_GRATUITE",
];
export const ROLES = [
  "UTILISATEUR",
  "ADMIN",
  "MANAGER",
  "FINANCIER",
  "OPERATIONNEL",
];
export const TRANSACTION_TYPE = ["CREDIT", "CAGNOTTE", "CAUTION"];
export const TRANSACTION_MONEY_OPERATION = [
  "MTN_MONEY",
  "INTERNE",
  "ORANGE_MONEY",
  "CASH",
  "MOOV_MONEY",
  "WAVE",
  "PAIEMENT_ELECTRONIQUE",
  "CREDIT",
];
export const TRANSACTION_STATUT = ["ANNULER", "EFFECTUER", "EN_ATTENTE"];
export const TYPE_SERVICE = ["PREVISITE", "POSITIONNEMENT", "PARRAINAGES"];
export const TYPE_OPERATION = ["CREDIT", "DEBIT"];
export const BARA_STATUS = ["EN_ATTENTE", "EN_COURS", "ANNULER", "REFUSER", "TERMINER"];
export const STATUT = ["ACTIF", "NON_ACTIF"];
export const TRANSACTION_EXPORT = ["ANNEE_EN_COURS", "JOUR_EN_COURS", "MOIS_EN_COURS"];
export const pageSizeReq = 10;
